import React from 'react';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { BeforeAfter } from '../components/BeforeAfter';
import { WhatYouGet } from '../components/WhatYouGet';
import { Testimonials } from '../components/Testimonials';
import { PricingSection } from '../components/PricingSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen w-full" style={{
    background: '#1A1A2E'
  }} data-id="element-280">
      <Navbar data-id="element-281" />
      <main data-id="element-282">
        <Hero data-id="element-283" />
        <ProblemSection data-id="element-284" />
        <BeforeAfter data-id="element-285" />
        <WhatYouGet data-id="element-286" />
        <Testimonials data-id="element-287" />
        <PricingSection data-id="element-288" />
        <GuaranteeSection data-id="element-289" />
      </main>
      <Footer data-id="element-290" />
    </div>;
}